const SEVERITY_LEVELS = [
  'default',
  'error',
  'warning',
  'primary'
] as const;

export type SeverityLevel = typeof SEVERITY_LEVELS[number]

export default (severity: number): SeverityLevel => SEVERITY_LEVELS[severity] ?? 'primary';
